<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NVxILU/tc-custom/9781398453524.jpg?1705056296958" alt="This image is the cover for the book It's All An Act"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's All An Act
      </h1>
      <p class="bookDescription body article font2">
        <p>From trainee teachers to veteran, battle-hardened staff, the recurring nightmare is of a class of teenagers who simply will not do as they are told. The stomach-clenching, hand-trembling, knee-jittering question we ask ourselves at the start of each new year is, ‘What if the pupils walk all over me?’ No matter how confident we are in our own abilities, regardless of our position in the school, irrespective of the reputation we have built for ourselves, if we do not ask ourselves that question, then sooner or later we are in for a nasty shock. When it comes to classroom management, we are all in the same boat. We all experience classroom management challenges. It’s All An Act offers a range of practical, no-nonsense, pragmatic strategies and techniques to try out, practise, adapt or abandon. It works on the premise that, to a great extent, classroom management is something we can do with pupils rather than to them. In response to the cry of, ‘What’s the point? That would never work!’ the reply is, ‘Give it a go. What have you got to lose?’ For colleagues under the cosh of lesson preparation, marking, administration, meetings and deadlines, it’s an easy read. What have you got to lose?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Wood
      </h2>
      
      <p class="authorDescription body article">Jim Wood was brought up in the East End of London. At the age of seven he decided to become a teacher and, from that point, never wavered from that goal. He taught English and English literature in comprehensive schools in Reading, Basingstoke and then Gosport where he became Head of Main School before embarking on a phased retirement. He has delivered classroom management training in secondary schools and at Southampton University for over twenty years where his practical, supportive, non-judgemental style has benefitted teachers at every stage of their career.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?720fe3e6